import React, { useState } from 'react';
import {
  LayoutDashboard,
  Settings,
  Shield,
  Bell,
  SlidersVertical,
  Crown,
} from 'lucide-react';
import OverviewTab from '../components/settings/OverviewTab';
import GeneralTab from '../components/settings/GeneralTab';
import PreferencesTab from '../components/settings/PreferencesTab';
import SecurityTab from '../components/settings/SecurityTab';
import PremiumTab from '../components/settings/PremiumTab';
import NotificationsTab from '../components/settings/NotificationsTab';

const tabs = [
  { label: 'Overview', icon: LayoutDashboard },
  { label: 'General', icon: Settings },
  { label: 'Preferences', icon: SlidersVertical },
  { label: 'Security', icon: Shield },
  // { label: 'Notifications', icon: Bell },
  { label: 'Premium', icon: Crown },
];

const SettingsPage = ({ isDarkMode, toggleTheme }) => {
  const [activeTab, setActiveTab] = useState('Overview');

  const renderContent = () => {
    switch (activeTab) {
      case 'Overview':
        return <OverviewTab isDarkMode={isDarkMode} />;
      case 'General':
        return <GeneralTab isDarkMode={isDarkMode} />;
      case 'Preferences':
        return (
          <PreferencesTab isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        );
      case 'Security':
        return <SecurityTab isDarkMode={isDarkMode} />;
      case 'Notifications':
        return <NotificationsTab isDarkMode={isDarkMode} />;
      case 'Premium':
        return <PremiumTab isDarkMode={isDarkMode} />;
      default:
        return <div className="p-6 text-sm text-gray-500">Coming Soon...</div>;
    }
  };

  return (
    <div
      className={`
    w-full 
    p-3 
    h-full
    overflow-y-auto 
    overflow-x-hidden 
    max-w-full    
    flex-shrink-0   
    ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}
  `}
    >
      <div className="w-full mx-auto max-w-full md:max-w-7xl ">
        <div className="mb-2">
          <h1
            className={`text-xl font-bold ${
              isDarkMode ? 'text-white' : 'text-gray-800'
            }`}
          >
            Profile & Settings
          </h1>
          <p
            className={`text-xs mt-2 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-500'
            }`}
          >
            Manage your Account and Preferences
          </p>
        </div>
        <div className="p-3 mb-2">
          <div
            className={`
              flex space-x-4 overflow-x-auto no-scrollbar md:space-x-8 border-b
              ${isDarkMode ? 'border-gray-600' : 'border-gray-200'}
            `}
          >
            {tabs.map((tab) => (
              <button
                key={tab.label}
                onClick={() => setActiveTab(tab.label)}
                className={`
                  pb-4 text-xs font-medium inline-flex items-center whitespace-nowrap
                  ${
                    activeTab === tab.label
                      ? 'text-brand border-b-2 border-brand'
                      : isDarkMode
                      ? 'text-gray-300 hover:text-white'
                      : 'text-gray-500 hover:text-gray-700'
                  }
                `}
              >
                <tab.icon className="w-4 h-4 mr-2" />
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {renderContent()}
      </div>
    </div>
  );
};

export default SettingsPage;
